module.exports = __webpack_public_path__ + "static/media/cap2-leg-mob.78721847.png";